import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import authHeader from "./auth-header";

export const fetchAllAgitems = (filters = {}) => {
  let queryArr = [];
  for (let key in filters) {
    if (filters[key] !== "") {
      queryArr.push(`${key}=${encodeURIComponent(filters[key])}`);
    }
  }
  let url = "?" + queryArr.join("&");
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const searchAllAgitems = (filters = {}) => {
  let queryArr = [];
  for (let key in filters) {
    if (filters[key] !== "") {
      queryArr.push(`${key}=${encodeURIComponent(filters[key])}`);
    }
  }
  let url = "?" + queryArr.join("&");
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/search${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const searchAllAgitemsWithoutSize = (filters = {}) => {
  let queryArr = [];
  for (let key in filters) {
    if (filters[key] !== "") {
      queryArr.push(`${key}=${encodeURIComponent(filters[key])}`);
    }
  }
  let url = "?" + queryArr.join("&");
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/without-size${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchOneAgitem = (id) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const createAgitem = (data) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/agitem/`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const updateAgitem = ({ id, data }) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/agitem/${id}`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const deleteAgitem = (id) => {
  return axios
    .delete(`${process.env.REACT_APP_BASE_URL}/agitem/${id}`, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const searchItemsForAsyncSelect = ({ query, vendorId = null }) => {
  let queryArr = [];
  
  if (query && query.trim().length >= 3) {
    queryArr.push(`query=${encodeURIComponent(query.trim())}`);
  } else {
    // Return empty array if query is too short
    return Promise.resolve([]);
  }
  
  if (vendorId) {
    queryArr.push(`vendorId=${encodeURIComponent(vendorId)}`);
  }
  
  const url = "?" + queryArr.join("&");
  
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/search-async-select${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data || [];
    })
    .catch((err) => {
      console.error("Error searching items for async select:", err);
      // Don't show toast for search errors as they happen frequently during typing
      return [];
    });
};

export const fetchItemsGroupedForSelect = ({ vendorId = null } = {}) => {
  let queryArr = [];
  
  if (vendorId) {
    queryArr.push(`vendorId=${encodeURIComponent(vendorId)}`);
  }
  
  const url = queryArr.length > 0 ? "?" + queryArr.join("&") : "";
  
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/grouped-for-select${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data || [];
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchItemDetailsWithSizes = (itemId) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/details-with-sizes/${itemId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data || [];
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchAgitemDetailsWithPricelist = (params = {}) => {
  let queryArr = [];
  for (let key in params) {
    if (params[key] !== undefined && params[key] !== "") {
      queryArr.push(`${key}=${encodeURIComponent(params[key])}`);
    }
  }
  let url = queryArr.length > 0 ? "?" + queryArr.join("&") : "";
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/details-with-pricelist${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const fetchBrandsByVendor = (vendorId) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/brands-by-vendor?vendorId=${vendorId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data?.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const getSingleItemByFilter = (params = {}) => {
  let queryArr = [];
  for (let key in params) {
    if (params[key] !== undefined && params[key] !== "") {
      queryArr.push(`${key}=${encodeURIComponent(params[key])}`);
    }
  }
  let url = queryArr.length > 0 ? "?" + queryArr.join("&") : "";
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/single-by-filter${url}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const bulkUpdatePackRatios = (data) => {
  return axios
    .put(`${process.env.REACT_APP_BASE_URL}/agitem/packratios`, data, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data?.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg);
      throw err;
    });
};

export const generateItemListReport = (params) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/agitem/item-list-report`, params, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Failed to generate item list report");
      throw err;
    });
};

export const getSchemeItem = (vendorId) => {
  return axios
    .get(`${process.env.REACT_APP_BASE_URL}/agitem/scheme-item?vendorId=${vendorId || ""}`, {
      headers: authHeader(),
    })
    .then((res) => {
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Failed to get scheme item");
      throw err;
    });
};


